import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSidebar } from '../../contexts/SidebarContext';
import HeaderNavigation from '../../components/ui/HeaderNavigation';
import MainSidebar from '../../components/ui/MainSidebar';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import OfferLetters from './OfferLetters';
import ProbationLetters from './ProbationLetters';
import IncrementLetters from './IncrementLetters';
import ExitLetters from './ExitLetters';
import HRManagement from './HRManagement';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const HumanResources = () => {
  const { user, userProfile } = useAuth();
  const { isCollapsed } = useSidebar();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const getTabFromPath = (path) => {
    if (path.includes('hr-management')) return 'hr-management';
    if (path.includes('increment-letters')) return 'increment-letters';
    if (path.includes('exit-letters')) return 'exit-letters';
    return 'hr-management';
  };

  const [activeTab, setActiveTab] = useState(() => getTabFromPath(location.pathname));

  React.useEffect(() => {
    const newTab = getTabFromPath(location.pathname);
    setActiveTab(newTab);
  }, [location.pathname]);

  const tabs = [
    { id: 'hr-management', label: 'HR Management', icon: 'Users', path: '/erp/hr/hr-management' },
    { id: 'increment-letters', label: 'Increment Letters', icon: 'TrendingUp', path: '/erp/hr/increment-letters' },
    { id: 'exit-letters', label: 'Exit Letters', icon: 'LogOut', path: '/erp/hr/exit-letters' }
  ];

  const handleTabChange = (tab) => {
    setActiveTab(tab.id);
    navigate(tab.path);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'hr-management':
        return <HRManagement />;
      case 'increment-letters':
        return <IncrementLetters />;
      case 'exit-letters':
        return <ExitLetters />;
      default:
        return <HRManagement />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header Navigation */}
      <HeaderNavigation
        onSidebarToggle={() => setSidebarOpen(!sidebarOpen)}
        user={user}
        userProfile={userProfile}
      />

      {/* Main Sidebar */}
      <MainSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main Content */}
      <div className={`pt-16 transition-all duration-300 ${isCollapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>
        <div className="p-6">
          {/* Breadcrumb */}
          <BreadcrumbNavigation />

          <div className="border-b border-border bg-background -mx-6 px-6 mb-6">
            <div className="pt-6">
              <h1 className="text-3xl font-bold text-foreground mb-2">Human Resources</h1>
              <p className="text-muted-foreground mb-4">Manage recruitment, letters, and employee lifecycle</p>
            </div>
            <div className="flex space-x-1 overflow-x-auto pb-4">
              {tabs.map((tab) => (
                <Button
                  key={tab.id}
                  variant={activeTab === tab.id ? 'default' : 'ghost'}
                  onClick={() => handleTabChange(tab)}
                  className="flex items-center gap-2 whitespace-nowrap"
                >
                  <Icon name={tab.icon} size={16} />
                  {tab.label}
                </Button>
              ))}
            </div>
          </div>

          <div>{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default HumanResources;

